import { render, staticRenderFns } from "./TransformInfo.vue?vue&type=template&id=1efb4661&"
import script from "./TransformInfo.vue?vue&type=script&lang=js&"
export * from "./TransformInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports